import concat from 'callbag-concat';
import of from 'callbag-of';

function concatWith() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (source) {
    return concat(source, of.apply(void 0, args));
  };
}

export default concatWith;



//////////////////
// WEBPACK FOOTER
// ./node_modules/callbag-concat-with/dist/callbag-concat-with.esm.js
// module id = 626
// module chunks = 0